
const moduleExports = Object.assign({},
  require('./services/index')
);

module.exports = moduleExports;
module.exports.default = moduleExports;
